import { Card, Col, Row } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import { ReactComponent as BriefPdf } from 'assets/img/icons/cardIcons/briefPdf.svg';

const BriefDisclaimer = ({ type }) => {
  return (
    <Card className="card-transparent space-vertical-sm briefCard no-break">
      <Row gutter={16} style={{ height: 30 }}>
        <Col span={2}>
          <BriefPdf />
        </Col>
        <Col span={22}>
          <div>
            <Trans
              i18nKey={
                type ? `professionalReport.pdf.brief.disclaimer1.${type}` : 'professionalReport.pdf.brief.disclaimer1'
              }
            />
          </div>
          <div>
            <Trans
              i18nKey={
                type ? `professionalReport.pdf.brief.disclaimer2.${type}` : 'professionalReport.pdf.brief.disclaimer2'
              }
              components={{ a: <a href="mailto:ltu.pardavimai@creditinfo.com" className="underlined" /> }}
            />
          </div>
        </Col>
      </Row>
    </Card>
  );
};
export default BriefDisclaimer;
